var map = {
	"./pdaDetails": [
		"WOwx",
		29
	],
	"./pdaDetails.vue": [
		"WOwx",
		29
	],
	"./returnDetails": [
		"nxnv",
		0,
		56
	],
	"./returnDetails.vue": [
		"nxnv",
		0,
		56
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "OJJQ";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/view/logistics/details lazy ^\.\/.*$
// module id = OJJQ
// module chunks = 191